import DashboardLayout from '@pages/Dashboard/components/DashboardLayout'

const DashboardPage = () => {
    return (
        <DashboardLayout>
            <h1>Home</h1>
        </DashboardLayout>
    )
}

export default DashboardPage
